export default __webpack_public_path__ + "static/media/Calendar.21a817c8.mov";